/* 布局 */
//前台
import Layout from "@views/layout";

const smslogRouter = {
  path: "/business",
  component: Layout,
  redirect: {
    name: "BUSINESS",
  },
  children: [
    {
      path: "smslog",
      name: "SMSLOG",
      meta: {
        title: "短信发送日志",
        sort: 1,
      },
      component: () => import("@views/business/smslog/index.vue"),
      redirect: {
        name: "SMSLOG_LIST",
      },
      children: [
        {
          path: "list",
          name: "SMSLOG_LIST",
          meta: {
            title: "短信发送日志",
            sort: 2,
            keepAlive: true,
          },
          component: () => import("@views/business/smslog/list.vue"),
        },
      ],
    },
  ],
};

export default smslogRouter;
